import { requestApi } from './Api';

export const getPatientInsuranceProfiles = async (navigate, params, signal) => {
  return requestApi({
    navigate,
    url: '/api/insurance_profiles/get',
    params,
    signal
  });
};

export const updateInsuranceProfile = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/insurance_profiles/update',
    params
  });
};

export const deleteInsuranceProfile = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/insurance_profiles/delete',
    params
  });
};

export const selectPatientInsurance = async (navigate, params) => {
  return requestApi({
    navigate,
    url: 'api/patient/insurance/select',
    params
  });
};

export const setNoPatientInsurance = async (navigate, params) => {
  return requestApi({
    navigate,
    url: 'api/patient/insurance/no_insurance',
    params
  });
};
